import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaContrato} from '../_models/tercero-up-pasarela-contrato';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaContratoService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasContratos';

  constructor(private httClient: HttpClient) {
  }

  listPasarelasContratos(idTerceroUPPasarela: string) {
    return this.httClient.get(`${this.rutServicio}/listPasarelasContratos/${idTerceroUPPasarela}`).pipe(map(res => res as TerceroUPPasarelaContrato[]));
  }
}
